import theme from '@styles/theme';

export default {
  container: (closed: boolean, marginBottom: number, marginTop: number, color?: string, backgroundColor?: string) => ({
    position: 'relative',
    width: '100%',
    height: closed ? '0' : 'auto',
    opacity: closed ? '0' : '1',
    padding: closed ? '0' : '16px',
    marginBottom: `${marginBottom}px`,
    marginTop: `${marginTop}px`,
    color: color || theme.rawColors.darkGrey700,
    backgroundColor: backgroundColor || theme.rawColors.dirtyPink200,
    display: 'flex',
    alignItems: 'flex-start',
    boxShadow: `0 2px 8px ${theme.rawColors.lightGrey500}`,
    transition: 'all .3s linear',
  }),
  itemContainer: (closed: boolean) => ({
    width: '100%',
    height: closed ? '0' : 'auto',
    padding: closed ? '0' : '16px',
    opacity: closed ? '0' : '1',
    marginBottom: '24px',
    backgroundColor: theme.rawColors.dirtyPink200,
    display: 'flex',
    alignItems: 'flex-start',
    boxShadow: `0 2px 8px ${theme.rawColors.lightGrey500}`,
    transition: 'all .3s linear',

    '&:last-of-type': {
      marginBottom: '0',
    },
  }),
  message: (closed: boolean, color?: string) => ({
    padding: '0 18px',
    color: color || theme.rawColors.darkGrey700,
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    fontSize: theme.fontSizes.smallText,
    lineHeight: closed ? '0' : '140%',
    opacity: closed ? '0' : '1',
    a: {
      color: `${color || theme.rawColors.darkGrey700} !important`,
    },
  }),
  buttonStyles: (closed: boolean) => ({
    height: closed ? '0' : '100%',
    opacity: closed ? '0' : '1',
  }),
  closeButtonStyles: (closed: boolean, color?: string) => ({
    marginLeft: 'auto',
    lineHeight: closed ? '0' : 'initial',
    height: closed && '0',
    '.icon': {
      svg: {
        path: {
          fill: `${color || theme.rawColors.darkGrey700} !important`,
        },
      },
    },
  }),
  list: {
    listStyle: 'none',
    marginTop: '24px',
  },
  infoIconStyles: (closed: boolean) => ({
    width: closed ? '0' : '20px',
    height: closed ? '0' : '20px',
    opacity: closed ? '0' : '1',
  }),
  refresh: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
};
